<div [ngClass]="wrapperClassComputed()">
  <app-navbar></app-navbar>
  <div [ngClass]="containerClassComputed()" class="pt-0 mx-auto sm:px-0 sm:mt-0 sm:pb-24">
    <router-outlet></router-outlet>
  </div>
  <app-bottomBar></app-bottomBar>
</div>

<app-drawer *ngIf="authStore.user()"></app-drawer>
